let browserHistory = require("react-router").browserHistory;
let connect = require("react-redux").connect;
import React from "react";

let actions = require("../actions/actions");
let CreatorRating = require("./moderation-creator-rating");

class ModerationPreviewMenu extends React.Component {
    render() {
        let creator = this.props.upload.creator,
            reviewUnsuspendBtn = this.renderReviewUnsuspendButton(creator);

        return (
            <section className="preview_info row">
                <div className="col-lg-2">
                    <span style={{ fontWeight: "bold", paddingTop: "14px" }}>
                        Currently Previewing:{" "}
                    </span>
                </div>
                <div className="navbar_header col-lg-3 row">
                    <a
                        href={`/fort/members/${creator.id}/`}
                        target="_blank"
                        className="profile avatar col-lg-3"
                    >
                        <div
                            style={{
                                backgroundImage: `url(${creator.avatar})`,
                                borderRadius: "50%",
                                width: "40px",
                                height: "40px",
                                backgroundSize: "40px"
                            }}
                        />
                    </a>
                    <div className="creator-info col-lg-9">
                        <div className="creator-name">{creator.name}</div>
                        <div className="creator-email">{creator.email}</div>
                    </div>
                </div>
                <div className="col-lg-7 row">
                    <div className="col-lg-offset-6 creator-actions">
                        {reviewUnsuspendBtn}
                        <button
                            className="ui_notes yellow"
                            onClick={this.viewNote.bind(this)}
                        >
                            Notes
                        </button>
                        <a
                            href={`/fort/members/${creator.id}/`}
                            className="text-link"
                            target="_blank"
                        >
                            View History
                        </a>
                    </div>
                </div>
            </section>
        );
    }

    renderReviewUnsuspendButton(creator) {
        let button;

        if (creator.is_suspended) {
            button = (
                <button
                    className="ui_flag green"
                    onClick={this.unSuspendCreator.bind(this, creator)}
                >
                    Unsuspend
                </button>
            );
        } else {
            button = (
                <button
                    onClick={this.reviewUpload.bind(this)}
                    className="blue"
                    style={{ padding: "10px 16px" }}
                >
                    Review Upload
                </button>
            );
        }

        return button;
    }

    reviewUpload() {
        this.props.showModal(null, "REVIEW_UPLOAD_CONFIRMATION", {
            saveForLater: false,
            upload: this.props.upload
        });
    }

    unSuspendCreator(creator) {
        this.props.unSuspendCreator(creator.id);
        browserHistory.push("/fort/modparty/creators/");
    }

    viewNote() {
        this.props.showModal(null, "VIEW_NOTES", { upload: this.props.upload });
    }
}

module.exports = connect(null, {
    unSuspendCreator: actions.unSuspendCreator,
    showModal: actions.showModal
})(ModerationPreviewMenu);
